// extracted by mini-css-extract-plugin
module.exports = {"subscribe":"Subscribe_subscribe__ZqazZ","noSpam":"Subscribe_noSpam__GHLqh","subscribeText":"Subscribe_subscribeText__un306"};